import api from './api';

export interface TipoPacote {
  id: string;
  data: TPData;
}

export interface TPData {
  nome: string;
  codigo: number;
}

export const getAllDisciplinas = () => api.get<TipoPacote[]>(`tipospacote/disciplinas`);
export const getAllTipos = () => api.get<TipoPacote[]>(`tipospacote/tipos`);

export const createDisciplina = (tipoPacote: Omit<TPData, 'codigo'>) =>
  api.post<TipoPacote>(`tipospacote/disciplinas`, tipoPacote);

export const createTipo = (tipoPacote: Omit<TPData, 'codigo'>) => api.post<TipoPacote>(`tipospacote/tipos`, tipoPacote);

export const updateDisciplina = (tipoPacote: any) => {
  const data = {
    id: tipoPacote.id,
    nome: tipoPacote.data.nome,
  };

  return api
    .put<boolean>(`tipospacote/disciplinas/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const updateTipo = (tipoPacote: any) => {
  const data = {
    id: tipoPacote.id,
    nome: tipoPacote.data.nome,
  };

  return api
    .put<boolean>(`tipospacote/tipos/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const deleteDisciplina = (id: string) => api.delete(`tipospacote/disciplinas/${id}`);
export const deleteTipo = (id: string) => api.delete(`tipospacote/tipos/${id}`);

export interface OrcamentoAcronimoPacote {
  ordemId: string;
  acronimoId: string;
  projetoId: string;
}

export const updateOrdemByAcronimoPacote = (ordemAcronimo: OrcamentoAcronimoPacote) => {
  return api
    .put<boolean>(`tipospacote/ordemInvestimento/${ordemAcronimo.ordemId}`, ordemAcronimo)
    .then(result => true)
    .catch(err => false);
};
